import router from '@/router';
import store from '@/store';

router.afterEach((to, from) => {
    // Determine which broadcast channels we need on this route (and which ones we had on the previous route)
    let needsChannels = _(to.matched).flatMap('meta.broadcastChannels').filter().uniq().value();
    let hadChannels = _(from.matched).flatMap('meta.broadcastChannels').filter().uniq().value();

    // Determine which channels need to be subscribed to and which need to be unsubscribed from
    let subscribeChannels = _.difference(needsChannels, hadChannels);
    let unsubscribeChannels = _.difference(hadChannels, needsChannels);

    // Unsubscribe from old channels and subscribe to new channels
    if (unsubscribeChannels.length)
        store.dispatch('data/unsubscribe', { channels: unsubscribeChannels });
    if (subscribeChannels.length)
        store.dispatch('data/subscribe', { channels: subscribeChannels });
});
